import type { google } from '@alugha/ima';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

type PlayPauseButtonProps = {
  isPaused: boolean;
  manager: google.ima.AdsManager | null;
};

export function PlayPauseButton({ isPaused, manager }: PlayPauseButtonProps) {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!manager) {
      return;
    }

    if (isPaused) {
      manager.resume();
    } else {
      manager.pause();
    }
  };

  return (
    <IconButton
      size="small"
      onClick={handleClick}
      aria-label={isPaused ? t('Resume') : t('Pause')}
      sx={{ color: theme => theme.palette.common.white }}
    >
      {isPaused ? <PlayArrowIcon fontSize="small" /> : <PauseIcon fontSize="small" />}
    </IconButton>
  );
}
